import { useAppDispatch, useAppSelector } from '@/config/hooks';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdTaskAlt } from 'react-icons/md';
import {
  Accordion,
  Avatar,
  Form,
  IconButton,
  List,
  Loader,
  Message,
  SelectPicker,
  Stack,
  TagPicker,
  useToaster
} from 'rsuite';
import PlusIcon from '@rsuite/icons/Plus';
import MinusIcon from '@rsuite/icons/Minus';
import {
  addIndividualAccess,
  getIndividualAccessByUser,
  updateIndividualAccess
} from '@/services/access.service';
import { useParams } from 'react-router-dom';
import { getFloors } from '@/services/floor.service';
import { getZones } from '@/services/zone.service';
import { Icon } from '@rsuite/icons';
import { VscSave } from 'react-icons/vsc';
import { RiMapPinUserLine, RiUserLocationLine } from 'react-icons/ri';

const slimText = {
  fontSize: '0.9em',
  color: '#97969B',
  fontWeight: 'lighter',
  paddingBottom: 5
};

const Header = props => {
  const { icon, title, name, ...rest } = props;
  return (
    <Stack {...rest} spacing={10} alignItems="flex-start">
      {icon}
      <Stack spacing={2} direction="column" alignItems="flex-start">
        <div>{title}</div>
        <div style={{ color: 'var(--rs-text-secondary)', fontSize: 12 }}>{name}</div>
      </Stack>
    </Stack>
  );
};
const Access = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const toaster = useToaster();

  const loading = useAppSelector((state: any) => state.access?.loading || false);
  const floors = useAppSelector((state: any) => state.floor?.data || [])?.map(item => {
    return { ...item, value: item._id, label: item.name };
  });

  const zones = useAppSelector((state: any) => state.zone?.data || [])?.map(item => {
    return { ...item, value: item._id, label: item.name };
  });

  const accessProfiles = useAppSelector((state: any) => state.accessProfile.data);

  const [selectedZones, setSelectedZones] = useState<any>([]);

  const access = useAppSelector((state: any) => state.access?.data);
  const accessProfile = useAppSelector((state: any) => state.users.item)?.Group?._id;

  const accessList = useMemo(
    () =>
      access.map(item => ({
        ...item,
        value: item?._id,
        label: item?.name
      })),
    [access]
  );

  const [localAccessList, setLocalAccessList] = useState<any>([]);

  useEffect(() => {
    const uniqueAccessList: any = [];

    const seenFloors = new Set();

    for (const access of accessList) {
      const floorId = access.floor?._id?.toString();

      if (!seenFloors.has(floorId)) {
        seenFloors.add(floorId);
        uniqueAccessList.push(access);
      }
    }
    setLocalAccessList(uniqueAccessList);
    setSelectedZones(Array.from(accessList, ({ _id }) => _id));
  }, [accessList]);

  useEffect(() => {
    dispatch(getIndividualAccessByUser(id));
    dispatch(getFloors());
    dispatch(getZones());
  }, [id]);

  const handleRemoveRow = index => {
    const values = [...localAccessList];
    const floorId = values[index]?.floor?._id || values[index]?.floor;
    const floorZones = zones?.filter(zone => zone.floor == floorId);
    const newZones = selectedZones.filter(zoneId => !floorZones.some(z => z._id === zoneId));
    setSelectedZones(newZones);
    values.splice(index, 1);
    setLocalAccessList(values);
  };

  const handleAddRow = () => {
    setLocalAccessList([
      ...localAccessList,
      {
        _id: null,
        floor: null
      }
    ]);
  };

  const handleChangeFloor = (index, event) => {
    const newArr = [...localAccessList];
    newArr[index].floor = event;
    setLocalAccessList(newArr);
  };
  const { t } = useTranslation();

  const handleSave = async () => {
    try {
      const data = {
        User: id,
        Zones: selectedZones
      };
      dispatch(await addIndividualAccess(data))
        .then(() => {
          toaster.push(
            <Message type="success" duration={5000} showIcon>
              {t('Updated successfully')}
            </Message>,
            { placement: 'topCenter' }
          );
          // setTimeout(() => {
          // window.location.reload();
          // }, 500);
        })
        .catch(e => {
          toaster.push(
            <Message type="error" duration={5000} showIcon>
              {t(e.message)}
            </Message>,
            { placement: 'topCenter' }
          );
        });
    } catch (error) {
      console.error(t('Erreur lors de la soumission :'), error);
    }
  };

  console.log('localAccessList', localAccessList);

  return (
    <div>
      <Form
        fluid
        // model={model}
        // disabled={currentUser.admin != 'super' && currentUser.admin != 'facility'}
      >
        <Accordion defaultActiveKey={1}>
          <Accordion.Panel
            header={
              <Header
                icon={<RiMapPinUserLine />}
                title={t('Profile accesses')}
                name={accessProfiles?.find(item => item._id == accessProfile)?.name}
              />
            }
            eventKey={1}
          >
            <List style={{ marginLeft: 70 }}>
              {accessProfiles
                ?.find(item => item._id == accessProfile)
                ?.zones?.map((access, index) => (
                  <List.Item key={index} style={{ fontSize: 12 }}>
                    <p style={{ color: 'var(--rs-text-primary-500)' }}>
                      <strong>{access.floor?.name}</strong>: {access.name}
                    </p>
                  </List.Item>
                ))}
            </List>
          </Accordion.Panel>
        </Accordion>
        <Accordion defaultActiveKey={1}>
          <Accordion.Panel
            header={
              <Header
                icon={<RiUserLocationLine />}
                title={t('Individual accesses')}
                // name={accessProfiles?.find(item => item._id == accessProfile)?.name}
              />
            }
            eventKey={1}
          >
            {/* <Stack style={{ marginTop: 50, marginBottom: 10, marginLeft: 10 }} spacing={5}>
          <RiUserLocationLine /> <h6 className="title">Manage individual user accesses </h6>
        </Stack> */}
            {loading ? (
              <Loader backdrop />
            ) : (
              <div className="ml-10">
                <List hover style={{ marginLeft: 70 }}>
                  {localAccessList?.map((item, index) => (
                    <List.Item key={index} index={index + 1}>
                      <Stack spacing={50} wrap>
                        <div style={{ textAlign: 'left' }}>
                          <div style={slimText}>{t('Floor')}</div>

                          <Form.Control
                            name="selectPicker"
                            accepter={SelectPicker}
                            data={floors}
                            value={item?.floor?._id || item?.floor}
                            onChange={e => {
                              handleChangeFloor(index, e);
                            }}
                            placement="auto"
                            style={{ width: 250 }}
                            disabledItemValues={
                              localAccessList?.length > 0
                                ? Array.from(localAccessList, ({ floor }) => floor?._id || floor)
                                : []
                            }
                          />
                        </div>
                        <div style={{ textAlign: 'left' }}>
                          <div style={slimText}>{t('Zones')}</div>

                          <TagPicker
                            data={zones?.filter(
                              zone => zone.floor == (item.floor?._id || item.floor)
                            )}
                            onChange={setSelectedZones}
                            value={selectedZones}
                            style={{ width: 250 }}
                            placement="auto"
                          />

                          {/* <SelectPicker
                        name="selectPicker"
                        data={zones?.filter(zone => zone.floor == (item.floor?._id || item.floor))}
                        value={item?._id}
                        // onChange={e => {
                        //   console.log(e, 'eeeeeeeeeeeee');
                        //   handleChangeFloor(index, e);
                        // }}
                        placement="auto"
                        style={{ width: 250 }}
                        // disabledItemValues={
                        //   localAccessList?.length > 0
                        //     ? Array.from(localAccessList, ({ floor }) => floor)
                        //     : []
                        // }
                      /> */}
                        </div>

                        <IconButton
                          onClick={() => {
                            handleRemoveRow(index);
                          }}
                          icon={<MinusIcon />}
                          size="xs"
                        />
                      </Stack>
                    </List.Item>
                  ))}
                </List>
                <IconButton
                  onClick={handleAddRow}
                  icon={<PlusIcon color="var(--rs-primary-800)" />}
                  style={{ marginTop: 10, marginLeft: 70 }}
                  id="add-access"
                />
              </div>
            )}
          </Accordion.Panel>
        </Accordion>
      </Form>

      <IconButton
        appearance="primary"
        icon={<Icon as={VscSave} />}
        style={{ float: 'right' }}
        onClick={handleSave}
        // disabled={currentUser.admin != 'super'}
      >
        {t('Save')}
      </IconButton>
    </div>
  );
};

export default Access;
